import { useParams } from 'react-router-dom';

type UseCurrentSimDataId = {
  currentSimDataId: string | null;
};

const useCurrentSimDataId = (): UseCurrentSimDataId => {
  const { simdata_id } = useParams();

  // データIDは、Reactの状態管理に含めるとEffectでの反映タイミングのズレによる問題が起こりやすいため、
  // URLのパスパラメータを唯一の情報源とする
  return { currentSimDataId: simdata_id || null };
};

export { useCurrentSimDataId };
